"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapMarker = void 0;
const api_1 = require("@react-google-maps/api");
const react_1 = __importDefault(require("react"));
const config_1 = require("../config");
const ICON_WIDTH = 33;
const ICON_HEIGHT = 40;
const MapMarker = ({ ...props }) => {
    const icon = {
        url: `${config_1.BASE_IMAGE_URL}/site/maps-marker.png`,
        scaledSize: new google.maps.Size(ICON_WIDTH, ICON_HEIGHT),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(ICON_WIDTH / 2, ICON_HEIGHT - 2),
    };
    return (react_1.default.createElement(api_1.MarkerF, { ...props, icon: {
            ...icon,
            ...props.icon,
        }, clickable: false }));
};
exports.MapMarker = MapMarker;
//# sourceMappingURL=MapMarker.js.map